const INFO = {
	main: {
		title: "Arya",
		name: "Arya Vats",
		email: "aryavats10@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/arya-vats",
		linkedin: "https://www.linkedin.com/in/arya-v-006325132/",
		instagram: "https://www.instagram.com/arya_vats10/",
	},

	homepage: {
		title: "Building, breaking and fixing since 2018",
		description:
			"My name is Arya. I am a Full Stack developer with expertise in Frontend as well as Backend technologies. I have experience in building secure and reliable web applications using various frameworks and technologies. Ranging from software development to diverse areas such as drones, aviation - I have had my fair share of experience in them, giving me the opportunity to be invited as a speaker for drones. I'm also the founder and technical lead of a society at college level.",
	},

	articles: {
		title: "Documenting each and every new thing that happens in my life....",
		description:
			"Collection of my long-form thoughts on other things I love",
	},

	projects: [
		{
			title: "Supply Chain simulation using blockchain",
			description:
				"Using blockchain and smart contracts to develop a system to easily view the supply chain of any product from manufacturing to wholesale to retailer to consumer ",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/arya-vats/supply-chain-truffle-react",
		},

		{
			title: "File sharing",
			description:
				"A simple file sharing Web App that uses nodejs, expressJs and a couple of packages to send and receive files direclty via email by dragging and dropping them.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/arya-vats/FileSharing",
		},

		{
			title: "Twitter Clone",
			description:
				"A clone of the famous twitter app made entirely using NoddeJS and Pug. Designed the backend and the likes system from scratch.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/arya-vats/TwitterClone",
		},

		{
			title: "Housetree",
			description:
				"A ReactJS based mini project that recommends the best house based on certain parameters.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/arya-vats/Housetree",
		},

		{
			title: "E-commerce website landing",
			description:
				"An ecommerce website created using reactJS. Mainly just to test some basic styling",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/arya-vats/ecommerce",
		},

		{
			title: "Home Automation",
			description:
				"Arduino code for home automation system that uses ultrasonic sensors to detect objects to switch off and switch on the lights automatically.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/cpp/cpp.png",
			linkText: "View Project",
			link: "https://github.com/arya-vats/Home-Automation",
		},
	],
};

export default INFO;
